import type { AgenticLogicRulePublishJobDto } from "@intelligems/ig-types";
import { IgButton, IgTooltip } from "@intelligems/ig-theme";
import { Square } from "lucide-react";

export interface RuleTestStopButtonProps {
  job: AgenticLogicRulePublishJobDto | undefined;
  repairActive: boolean;
  isStopping: boolean;
  onStop: () => void;
}

/**
 * What a stop does, said before the click: the check already running is not
 * interrupted — the sandbox has no cancellation point inside a gate — so it
 * finishes and the checks after it are skipped.
 */
export const STOP_TESTS_HINT =
  "The check that is running finishes first; the ones after it are skipped.";

export const RuleTestStopButton = ({
  job,
  repairActive,
  isStopping,
  onStop,
}: RuleTestStopButtonProps) => {
  if (
    repairActive ||
    job?.mode !== "dry_run" ||
    (job.status !== "queued" && job.status !== "running")
  )
    return null;

  return (
    <IgTooltip title={STOP_TESTS_HINT}>
      <IgButton
        variant="outlined"
        size="mini"
        color="warning"
        startIcon={<Square size={14} />}
        disabled={isStopping}
        onClick={onStop}
      >
        {isStopping ? "Stopping after this check…" : "Stop tests"}
      </IgButton>
    </IgTooltip>
  );
};
